// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/cp_swap.proto (package morfi.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EventMetadata, Side } from "./common_pb.js";
import { file_morfi_v1_common } from "./common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/cp_swap.proto.
 */
export const file_morfi_v1_cp_swap: GenFile = /*@__PURE__*/
  fileDesc("ChZtb3JmaS92MS9jcF9zd2FwLnByb3RvEghtb3JmaS52MSKeAgoNTHBDaGFuZ2VFdmVudBIlCgRtZXRhGAEgASgLMhcubW9yZmkudjEuRXZlbnRNZXRhZGF0YRIPCgdwb29sX2lkGAIgASgMEhgKEGxwX2Ftb3VudF9iZWZvcmUYAyABKAQSHAoUdG9rZW5fMF92YXVsdF9iZWZvcmUYBCABKAQSHAoUdG9rZW5fMV92YXVsdF9iZWZvcmUYBSABKAQSFgoOdG9rZW5fMF9hbW91bnQYBiABKAQSFgoOdG9rZW5fMV9hbW91bnQYByABKAQSHAoUdG9rZW5fMF90cmFuc2Zlcl9mZWUYCCABKAQSHAoUdG9rZW5fMV90cmFuc2Zlcl9mZWUYCSABKAQSEwoLY2hhbmdlX3R5cGUYCiABKA0ixAMKCVN3YXBFdmVudBIlCgRtZXRhGAEgASgLMhcubW9yZmkudjEuRXZlbnRNZXRhZGF0YRIPCgdwb29sX2lkGAIgASgMEhoKEmlucHV0X3ZhdWx0X2JlZm9yZRgDIAEoBBIbChNvdXRwdXRfdmF1bHRfYmVmb3JlGAQgASgEEhQKDGlucHV0X2Ftb3VudBgFIAEoBBIVCg1vdXRwdXRfYW1vdW50GAYgASgEEhoKEmlucHV0X3RyYW5zZmVyX2ZlZRgHIAEoBBIbChNvdXRwdXRfdHJhbnNmZXJfZmVlGAggASgEEhIKCmJhc2VfaW5wdXQYCSABKAgSEgoKaW5wdXRfbWludBgKIAEoDBITCgtvdXRwdXRfbWludBgLIAEoDBIRCgl0cmFkZV9mZWUYDCABKAQSFAoMcHJvdG9jb2xfZmVlGA0gASgEEhAKCGZ1bmRfZmVlGA4gASgEEhMKC2NyZWF0b3JfZmVlGA8gASgEEhwKFGNyZWF0b3JfZmVlX29uX2lucHV0GBAgASgIEhkKEWlucHV0X3Rva2VuX293bmVyGBEgASgMEhoKEm91dHB1dF90b2tlbl9vd25lchgSIAEoDCKZAwoPQW1tVXNlckFjdGl2aXR5EhMKC3NlcXVlbmNlX2lkGAEgASgMEgoKAnRzGAIgASgEEisKBGtpbmQYAyABKA4yHS5tb3JmaS52MS5BbW1Vc2VyQWN0aXZpdHlLaW5kEhwKBHNpZGUYBCABKA4yDi5tb3JmaS52MS5TaWRlEg0KBWFjdG9yGAUgASgJEhEKCWFtb3VudF9kNhgGIAEoBBIdChVwb3N0X291dGNvbWVfcHJpY2VfZDkYByABKAQSHgoWcG9zdF9xdW90ZV9yZXNlcnZlc19kNhgIIAEoBBIOCgZtYXJrZXQYCSABKAkSGAoLb3V0Y29tZV9pZHgYCiABKA1IAIgBARIgChhwb3N0X291dGNvbWVfcmVzZXJ2ZXNfZDYYCyABKAQSHwoSZXhlY3V0aW9uX3ByaWNlX2Q5GAwgASgESAGIAQESFAoMb3V0Y29tZV9taW50GA0gASgJEg8KB3Bvb2xfaWQYDiABKAlCDgoMX291dGNvbWVfaWR4QhUKE19leGVjdXRpb25fcHJpY2VfZDkq4wEKE0FtbVVzZXJBY3Rpdml0eUtpbmQSJgoiQU1NX1VTRVJfQUNUSVZJVFlfS0lORF9VTlNQRUNJRklFRBAAEiAKHEFNTV9VU0VSX0FDVElWSVRZX0tJTkRfVFJBREUQARIkCiBBTU1fVVNFUl9BQ1RJVklUWV9LSU5EX0xJUVVJRElUWRACEigKJEFNTV9VU0VSX0FDVElWSVRZX0tJTkRfQ09ORklHVVJBVElPThADEjIKLkFNTV9VU0VSX0FDVElWSVRZX0tJTkRfUkVDT05DSUxJQVRJT05fUkVRVUlSRUQQBGIGcHJvdG8z", [file_morfi_v1_common]);

/**
 * @generated from message morfi.v1.LpChangeEvent
 */
export type LpChangeEvent = Message<"morfi.v1.LpChangeEvent"> & {
  /**
   * @generated from field: morfi.v1.EventMetadata meta = 1;
   */
  meta?: EventMetadata | undefined;

  /**
   * @generated from field: bytes pool_id = 2;
   */
  poolId: Uint8Array;

  /**
   * @generated from field: uint64 lp_amount_before = 3;
   */
  lpAmountBefore: bigint;

  /**
   * @generated from field: uint64 token_0_vault_before = 4;
   */
  token0VaultBefore: bigint;

  /**
   * @generated from field: uint64 token_1_vault_before = 5;
   */
  token1VaultBefore: bigint;

  /**
   * @generated from field: uint64 token_0_amount = 6;
   */
  token0Amount: bigint;

  /**
   * @generated from field: uint64 token_1_amount = 7;
   */
  token1Amount: bigint;

  /**
   * @generated from field: uint64 token_0_transfer_fee = 8;
   */
  token0TransferFee: bigint;

  /**
   * @generated from field: uint64 token_1_transfer_fee = 9;
   */
  token1TransferFee: bigint;

  /**
   * @generated from field: uint32 change_type = 10;
   */
  changeType: number;
};

/**
 * Describes the message morfi.v1.LpChangeEvent.
 * Use `create(LpChangeEventSchema)` to create a new message.
 */
export const LpChangeEventSchema: GenMessage<LpChangeEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_cp_swap, 0);

/**
 * @generated from message morfi.v1.SwapEvent
 */
export type SwapEvent = Message<"morfi.v1.SwapEvent"> & {
  /**
   * @generated from field: morfi.v1.EventMetadata meta = 1;
   */
  meta?: EventMetadata | undefined;

  /**
   * @generated from field: bytes pool_id = 2;
   */
  poolId: Uint8Array;

  /**
   * @generated from field: uint64 input_vault_before = 3;
   */
  inputVaultBefore: bigint;

  /**
   * @generated from field: uint64 output_vault_before = 4;
   */
  outputVaultBefore: bigint;

  /**
   * @generated from field: uint64 input_amount = 5;
   */
  inputAmount: bigint;

  /**
   * @generated from field: uint64 output_amount = 6;
   */
  outputAmount: bigint;

  /**
   * @generated from field: uint64 input_transfer_fee = 7;
   */
  inputTransferFee: bigint;

  /**
   * @generated from field: uint64 output_transfer_fee = 8;
   */
  outputTransferFee: bigint;

  /**
   * @generated from field: bool base_input = 9;
   */
  baseInput: boolean;

  /**
   * @generated from field: bytes input_mint = 10;
   */
  inputMint: Uint8Array;

  /**
   * @generated from field: bytes output_mint = 11;
   */
  outputMint: Uint8Array;

  /**
   * @generated from field: uint64 trade_fee = 12;
   */
  tradeFee: bigint;

  /**
   * @generated from field: uint64 protocol_fee = 13;
   */
  protocolFee: bigint;

  /**
   * @generated from field: uint64 fund_fee = 14;
   */
  fundFee: bigint;

  /**
   * @generated from field: uint64 creator_fee = 15;
   */
  creatorFee: bigint;

  /**
   * @generated from field: bool creator_fee_on_input = 16;
   */
  creatorFeeOnInput: boolean;

  /**
   * @generated from field: bytes input_token_owner = 17;
   */
  inputTokenOwner: Uint8Array;

  /**
   * @generated from field: bytes output_token_owner = 18;
   */
  outputTokenOwner: Uint8Array;
};

/**
 * Describes the message morfi.v1.SwapEvent.
 * Use `create(SwapEventSchema)` to create a new message.
 */
export const SwapEventSchema: GenMessage<SwapEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_cp_swap, 1);

/**
 * @generated from message morfi.v1.AmmUserActivity
 */
export type AmmUserActivity = Message<"morfi.v1.AmmUserActivity"> & {
  /**
   * Opaque 15-byte big-endian ordering key.
   *
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: morfi.v1.AmmUserActivityKind kind = 3;
   */
  kind: AmmUserActivityKind;

  /**
   * @generated from field: morfi.v1.Side side = 4;
   */
  side: Side;

  /**
   * @generated from field: string actor = 5;
   */
  actor: string;

  /**
   * @generated from field: uint64 amount_d6 = 6;
   */
  amountD6: bigint;

  /**
   * Post-swap projection fields, both derivable from the raw SwapEvent after
   * its durable apply. They drive the live price /
   * liquidity / market-cap on the graduated detail grid without an RPC.
   * `holder_count` and circulating `supply` are intentionally NOT here:
   * holders are post-persist DB state and supply is constant across AMM
   * swaps — both come from the REST endpoint (refreshed on staleTime).
   *
   * spot price after the swap
   *
   * @generated from field: uint64 post_outcome_price_d9 = 7;
   */
  postOutcomePriceD9: bigint;

  /**
   * pool quote reserve (liquidity)
   *
   * @generated from field: uint64 post_quote_reserves_d6 = 8;
   */
  postQuoteReservesD6: bigint;

  /**
   * Routing identity (mirrors MarketUserActivity.market / outcome_idx) so SDK
   * realtime recipes can match the firing market/outcome row in a list and
   * index-set the per-outcome price. Both implicit elsewhere but required in
   * the payload for response-side row matching.
   *
   * market pubkey (base58)
   *
   * @generated from field: string market = 9;
   */
  market: string;

  /**
   * winning outcome index
   *
   * @generated from field: optional uint32 outcome_idx = 10;
   */
  outcomeIdx?: number | undefined;

  /**
   * pool outcome-token reserve
   *
   * @generated from field: uint64 post_outcome_reserves_d6 = 11;
   */
  postOutcomeReservesD6: bigint;

  /**
   * Exact quote delta / outcome delta for the trade fact and chart tape.
   * Distinct from the post-reserve spot mark above; absent on older payloads.
   *
   * @generated from field: optional uint64 execution_price_d9 = 12;
   */
  executionPriceD9?: bigint | undefined;

  /**
   * Repository-committed identity. Raw CP-Swap events do not carry Morfi
   * market identity, so publishers must never infer these after persistence.
   *
   * @generated from field: string outcome_mint = 13;
   */
  outcomeMint: string;

  /**
   * @generated from field: string pool_id = 14;
   */
  poolId: string;
};

/**
 * Describes the message morfi.v1.AmmUserActivity.
 * Use `create(AmmUserActivitySchema)` to create a new message.
 */
export const AmmUserActivitySchema: GenMessage<AmmUserActivity> = /*@__PURE__*/
  messageDesc(file_morfi_v1_cp_swap, 2);

/**
 * @generated from enum morfi.v1.AmmUserActivityKind
 */
export enum AmmUserActivityKind {
  /**
   * @generated from enum value: AMM_USER_ACTIVITY_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AMM_USER_ACTIVITY_KIND_TRADE = 1;
   */
  TRADE = 1,

  /**
   * @generated from enum value: AMM_USER_ACTIVITY_KIND_LIQUIDITY = 2;
   */
  LIQUIDITY = 2,

  /**
   * Authoritative pool/config observation completed on the existing bounded
   * outcome activity dimension. Clients reconcile their full snapshot.
   *
   * @generated from enum value: AMM_USER_ACTIVITY_KIND_CONFIGURATION = 3;
   */
  CONFIGURATION = 3,

  /**
   * A committed admin mutation invalidated the static executable snapshot.
   *
   * @generated from enum value: AMM_USER_ACTIVITY_KIND_RECONCILIATION_REQUIRED = 4;
   */
  RECONCILIATION_REQUIRED = 4,
}

/**
 * Describes the enum morfi.v1.AmmUserActivityKind.
 */
export const AmmUserActivityKindSchema: GenEnum<AmmUserActivityKind> = /*@__PURE__*/
  enumDesc(file_morfi_v1_cp_swap, 0);

